import DataUrlGeneratorInterface from "./DataUrlGeneratorInterface.js";

// this doesn't work for it's intended use case (creating base 64 data urls of images)
// because we need special CORS headers to trick the browser
// so the bizapi is being used for this now

class DataUrlBase64Generator extends DataUrlGeneratorInterface{
    constructor(axios) {
        super();
        this.axios = axios;
    }

    generate = async (url) => {
        let result = {
            data_url: "",
            is_error: false
        }

        const { array_buffer, content_type, is_error } = await this._getData(url);
        if (is_error) {
            result.is_error = true;
            return result;
        }
        const base64Data = this._arrayBufferToBase64(array_buffer);
        result.data_url = this._assembleDataUrl(content_type, base64Data);
        return result; 
    }

    _getData = async (url) => {
        let result = {
            array_buffer: "",
            content_type: "",
            is_error: false
        }
        try {
            console.log(url)
            const response = await this.axios.get(url, { responseType: "arraybuffer" });
            result.content_type = response.headers["content-type"];
            result.array_buffer = response.array_buffer;
        } catch (error) {
            console.error(error);
            result.is_error = true;         
        }
        return result;
    }

    _arrayBufferToBase64(arrayBuffer) {
        const uint8Array = new Uint8Array(arrayBuffer);
        const binaryString = String.fromCharCode.apply(null, uint8Array);
        return btoa(binaryString);
    }

    _assembleDataUrl(contentType, base64Data) {
        return `data:${contentType};base64,${base64Data}`;
    }
}

export default DataUrlBase64Generator;

